export default function About() {
  return (
    <section id="about" className="bg-amber-50/40 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-6">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900">About Us</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">
                Hydville Systems Ltd. (HV)
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed text-justify">
                originates from research launched in 2010 by a group of technologists committed to redefining the future of clean energy. From the outset, the initiative focused on high-impact innovation with the potential to reshape the energy, power, and transportation sectors.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">
                Our proprietary platform
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed text-justify">
                has undergone extensive evaluation and has demonstrated performance characteristics that significantly exceed those of conventional systems. Our technological capability and assets position Hydville at the forefront of next-generation hydrogen solutions and offers strong potential for strategic partnerships, commercial deployment, and long-term value creation.
              </p>
            </div>
          </div>

          {/* Right Column - Logo */}
          <div className="flex items-center justify-center lg:justify-end">
            <img 
              src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/4c5f2ca657b3320dc623dc3767304a96.png" 
              alt="Hydville Systems Logo" 
              className="w-full max-w-md h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}